<div class="home">
    <div class="dashboardTitle">
        <div>
            <h1>Classroom Dashboard</h1>
            <div>View your individual class statistics!</div>
        </div>
        <div class="btn">
            Download Class Report
        </div>
    </div>
    <div class="bgImg">
        <img src="../../../assets/icons/booknerds.png">
    </div>
</div>
